import { useNavigate } from 'react-router-dom'

type ResumeDistributionActionsProps = {
  handleInitialClick: () => void
  handleInProgressClick: () => void
  handleCompletedClick: () => void
}

export const useResumeDistributionActions = (): ResumeDistributionActionsProps => {
  const navigate = useNavigate()

  const handleInitialClick = () => {
    navigate('/resume-distribution')
  }

  const handleInProgressClick = () => {
    navigate('/resume-distribution/dashboard')
  }

  const handleCompletedClick = () => {
    // TODO: Implement completed click
  }

  return {
    handleInitialClick,
    handleInProgressClick,
    handleCompletedClick,
  }
}
